import Auth_API from "./apiConfig"
export const authApi = {
	login: async (credentials) => {
		try {
			const response = await Auth_API.post("user/login", credentials)
			if(response.data.response?.otp){
				prompt('Your OTP is', response.data.response.otp)
			}
			return response.data
		} catch (error) {
			console.error(
				"Login failed",
				error?.response?.data || error.message
			)
			throw error // Re-throw for higher-level handling
		}
	},
	verify_otp: async (credentials) => {
		try {
			const response = await Auth_API.post("user/verifyOTP", credentials)
			return response.data
			
		} catch (error) {
			console.error(
				"Verify OTP failed",
				error?.response?.data || error.message
			)
			throw error // Re-throw for higher-level handling
		}
	},
	myProfile: async () => {
		try {
			const response = await Auth_API.get("user/me")
			return response.data
		} catch (error) {
			console.error(
				"My Profile failed",
				error?.response?.data || error.message
			)
			throw error // Re-throw for higher-level handling
		}
	},

	logout: async () => {
		try {
			const resp = await Auth_API.get("user/logout")
			return resp.data
		} catch (error) {
			console.error(
				"Logout failed",
				error?.response?.data || error.message
			)
		}
	},
}

export const userApi = {
    updateUserData: async ( data ) => {
        try {
            const response = await Auth_API.post(`user/update`, data, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            return response.data;
        } catch (error) {
            console.error("Update User Data failed", error?.response?.data || error.message);
            throw error; // Re-throw for higher-level handling
        }
    },

    updateCompanyDetails: async (params) => {
        try {
			const { companyId, formData } = params;
            const response = await Auth_API.post(`user/company/update/${companyId}`, formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            return response.data;
        } catch (error) {
            console.error("Update Company Details failed", error?.response?.data || error.message);
            throw error; // Re-throw for higher-level handling
        }
    },
    
    fetchIndustries: async () => {
        try {
            const response = await Auth_API.post(`config/type/industries`);
            return response.data;
        } catch (error) {
            console.error("Fetch Industries failed", error?.response?.data || error.message);
            throw error; // Re-throw for higher-level handling
        }
    },

	fetchNatureOfBusiness: async () => {
		try {
			const response = await Auth_API.post(`config/type/nature_of_business`);
			return response.data;
		} catch (error) {
			console.error("Fetch Nature of Business failed", error?.response?.data || error.message);
			throw error; // Re-throw for higher-level handling
		}
	},
}

export const uploadApi = {
	uploadProfileImage: async (fileInput, username = "guest", tag="profileimage") => {
		try {
			const formData = new FormData()
			formData.append("file", fileInput.files[0])
			formData.append("user", username)
			formData.append("tag",tag)

			const response = await Auth_API.post("s3/upload-file", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})

			return response.data
		} catch (error) {
			console.error(
				"Upload Profile Image failed",
				error?.response?.data || error.message
			)
			throw error // Re-throw for higher-level handling
		}
	},
}
